import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Portfolio from './Portfolio';

ReactDOM.render(
  <Portfolio />,
  document.getElementById('root')
);